import { Layout } from '@/components/layout/Layout';
import { useEffect } from 'react';

const CONVOCORE_URL = 'https://pulsia.convocore.app/';

export default function ConnexionAlxioPage() {
  useEffect(() => {
    window.location.replace(CONVOCORE_URL);
  }, []);

  return (
    <Layout>
      <section className="w-full pt-24 lg:pt-28">
        <div className="section-container py-12 text-center">
          <p className="text-muted-foreground mb-4">
            Redirection en cours vers l’espace client…
          </p>
          <a
            href={CONVOCORE_URL}
            className="text-primary underline underline-offset-4 hover:opacity-80 transition-opacity"
          >
            Ouvrir l’espace client
          </a>
        </div>
      </section>
    </Layout>
  );
}
